import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from "@ngrx/data";
import {PaymentRequestReminderConverter} from "./api/entity/converter/paymentRequestReminder.converter";
import {PaymentRequestReminderSummaryConverter} from "./api/entity/converter/paymentRequestReminderSummary.converter";
import {PaymentRequestReminderRepository} from "./service/ngrx/paymentRequestReminder.repository";
import {PaymentRequestReminderDataService} from "./service/ngrx/paymentRequestReminderData.service";
import {PaymentRequestReminderDataServiceAdapter} from "./service/ngrx/paymentRequestReminderDataService.adapter";
import {PaymentRequestReminderSummaryDataServiceAdapter} from "./service/ngrx/paymentRequestReminderSummaryDataService.adapter";

@NgModule({
    providers: [
        PaymentRequestReminderRepository,
        PaymentRequestReminderDataService,
        PaymentRequestReminderDataServiceAdapter,
        PaymentRequestReminderSummaryDataServiceAdapter,
        PaymentRequestReminderConverter,
        PaymentRequestReminderSummaryConverter,
    ],
})
export class PaymentRequestReminderModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                repository: PaymentRequestReminderRepository,
                dataService: PaymentRequestReminderDataService,
    ) {

        entityDataService.registerServices({
            'PaymentRequestReminder': dataService,
        });

        entityServices.registerEntityCollectionServices({
            'PaymentRequestReminder': repository,
        });

        //  errorMessages.set('PRODUCT_SAVE_CODE_ALREADY_USED', 'Un produit avec ce code existe déjà');
    }
}
